import { render, staticRenderFns } from "./GeneralSnackbar.vue?vue&type=template&id=9227d932"
import script from "./GeneralSnackbar.vue?vue&type=script&lang=js"
export * from "./GeneralSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports